import React, {useEffect, useState} from 'react';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import AdminServiciosAPI from './servicios/AdminServicios';
import Reproductor from './ componentes/Reproductor';

function App() {
  const [cargando, setCargando] = useState(false);
  const [datos, setDatos] = useState(null);

  const cargarDatos = async() => {
    const urlParams = new URLSearchParams(window.location.search)
    const id = urlParams.get('id')
    //console.log('id',idcomprobante)
    if(id  && id!==''){
        setCargando(true)
        const response = await AdminServiciosAPI.getRegistro(`consulta/${id}`);
        if (response) {
            const respuesta = await response.json();
            if(respuesta.datos){
                //console.log('datos',respuesta.datos)
                document.title = respuesta.datos.nombre
                setDatos(respuesta.datos)
            }
        }
        setCargando(false)
    }
  }

  useEffect(() => {
    cargarDatos()
  },[])

  return (
    <div className="container-fluid">
      {cargando && <div>Cargando video...</div>}
      {datos && <Reproductor urlData={datos.datos.url} texto={datos.datos.html}/>}
    </div>
  );
}

export default App;
